import React from "react";
import { Route } from "react-router-dom";
import { OrganizationFeatureCard } from "./OrganizationFeatureCard";
import { OrganizationFeatureEditDialog } from "./organization-feature-edit-dialog/OrganizationFeatureEditDialog";
import { OrganizationFeatureUIProvider } from "./OrganizationFeatureUIContext";

export function OrganizationFeaturePage({ history }) {
  const organizationFeatureUIEvents = {
    openEditOrganizationFeaturePage: organization_uuid => {
      history.push(`/admin/organization/feature/${organization_uuid}`);
    }
  };

  return (
    <OrganizationFeatureUIProvider
      organizationFeatureUIEvents={organizationFeatureUIEvents}
    >
      <Route path="/admin/organization/feature/:org_id">
        {({ history, match }) => (
          <OrganizationFeatureEditDialog
            show={match != null}
            id={match && match.params.org_id}
            onHide={() => {
              history.push("/admin/organization/feature");
            }}
          />
        )}
      </Route>
      <OrganizationFeatureCard />
    </OrganizationFeatureUIProvider>
  );
}
